import DropdownMenu from 'OK/menu/DropdownMenu';

class MoreBtn {
    constructor(options) {
        this._createBtn(options.el);
    }

    _createBtn(el) {

        this._el = el;

        this._menu = new DropdownMenu({
            triggerEvent: 'click',
            trigger: this._el,
            align: 'left',
            // меню красиво смотрится смещенным влево вверх
            margin: -10,
            vmargin: -5,
            elCls: el.scMenuCls !== '' ? [
                'sc-menu__nopadding',
                '__noarrow',
                '__more-dropdown',
                el.scMenuCls
            ] : ['sc-menu__nopadding',
                '__noarrow',
                '__more-dropdown']
        });

        this._menu.activate();

    }

    getEl() {
        return this._el;
    }

    addItem(el) {
        this._menu.getEl().appendChild(el);
    }

    destroy() {
        this._menu.destroy();
        OK.util.clean(this);
    }
}


export default MoreBtn;
